var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExportDataPopout',{attrs:{"assetGuids":_vm.assetGuids,"exportOptionsObject":_vm.exportOptionsObject},scopedSlots:_vm._u([{key:"buttonContent",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"integrity-blue-button initiate-export-button",attrs:{"small":""}},'v-btn',attrs,false),on),[_vm._v(" "+_vm._s(_vm.selectedAssets ? "Export Project" : "Export Data")+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }